import React from 'react';
import { HiComputerDesktop } from "react-icons/hi2";
import { FaMoneyBill } from "react-icons/fa";
import { BsPeopleFill } from "react-icons/bs";
import { GrCloudSoftware } from "react-icons/gr";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { FaBusinessTime } from "react-icons/fa";

function why() {
    return (
        <section id="reasons" style={{paddingTop:'35px', paddingBottom:'35px'}}>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="section-label">The Investment Case</div>
        <h2 class="section-title">Six Compelling<br/><em>Reasons to Invest</em></h2>
      </div>
      <div class="col-lg-6 d-flex align-items-end">
        <p style={{color:"white", fontSize:'0.9rem', lineHeight: '1.8', marginBottom:'12px'}}>
          The following factors distinguish this offering and reflect the advantages of investing alongside Nexora Systems.
        </p>
      </div>
    </div>

    <div class="reasons-grid fade-up">
      {/* <!-- 1 --> */}
      <div class="reason-card">
        <span class="reason-num">01</span>
        <div class="reason-icon"><HiComputerDesktop /></div>
        <h4>Positioned at the Intersection of AI & Automation</h4>
        <p>Artificial intelligence is moving beyond experimentation and into everyday business operations.

Nexora is focused on the practical application of AI: automating processes, reducing administrative work, connecting business systems, and helping employees make faster, better-informed decisions.

We believe the largest opportunity may not be replacing entire software platforms, but making the software businesses already use significantly more intelligent.</p>
         {/* <div class="reason-metric">22 Markets</div>
        <div class="reason-metric-label">Active geographic diversification</div>  */}
      </div>
      {/* <!-- 2 --> */}
      <div class="reason-card">
        <span class="reason-num">02</span>
        <div class="reason-icon"><FaMoneyBill /></div>
        <h4>Recurring Revenue Business Model</h4>
        <p>Nexora is being designed around recurring subscription revenue.

Customers can subscribe to the platform based on company size, functionality, number of connected systems, and usage. This creates opportunities for predictable recurring revenue while allowing customer relationships to expand as platform utilization increases.</p>
        {/* <div class="reason-metric">8–12% p.a.</div>
        <div class="reason-metric-label">Target preferred return to investors</div>  */}
      </div>
      {/* <!-- 3 --> */}
      <div class="reason-card">
        <span class="reason-num">03</span>
        <div class="reason-icon"><BsPeopleFill /></div>
        <h4>Large Expansion Opportunity Within Existing Customers</h4>
        <p>Nexora's initial customer relationship may begin with a single workflow or department.

A customer could initially use Nexora to automate sales administration, for example, and subsequently expand into customer service, finance, human resources, reporting, and internal operations.

This creates a potential land-and-expand strategy in which revenue per customer can increase over time without requiring the company to acquire an entirely new customer for every incremental source of revenue.</p>
        {/* <div class="reason-metric">94.2% Occupied</div>
        <div class="reason-metric-label">Weighted average across portfolio</div>  */}
      </div>
      {/* <!-- 4 --> */}
      <div class="reason-card">
        <span class="reason-num">04</span>
        <div class="reason-icon"><GrCloudSoftware /></div>
        <h4>Designed to Integrate Rather Than Replace</h4>
        <p>Replacing enterprise software can be expensive, disruptive, and time-consuming.

Nexora takes a different approach.

Our platform is designed to connect with the software businesses already depend on, allowing companies to add intelligent automation without completely rebuilding their technology infrastructure.

The more systems Nexora can connect, the more valuable the platform can potentially become as a central operating layer.</p>
        {/* <div class="reason-metric">≤55% LTV</div>
        <div class="reason-metric-label">Maximum leverage on portfolio assets</div>  */}
      </div>
      {/* <!-- 5 --> */}
      <div class="reason-card">
        <span class="reason-num">05</span>
        <div class="reason-icon"><RiMoneyDollarCircleFill /></div>
        <h4>Multiple Paths to Revenue Expansion</h4>
        <p>Nexora's initial SaaS subscription represents only one potential source of revenue.

Over time, the company intends to develop additional monetization opportunities through:

Platform subscriptions → AI usage → premium agents → enterprise functionality → integrations → additional departments

This creates multiple potential avenues for increasing revenue from the same customer base while broadening the company's overall addressable market.</p>
         {/* <div class="reason-metric">~35%</div>
        <div class="reason-metric-label">Estimated tax-sheltered income</div>  */}
      </div>
      {/* <!-- 6 --> */}
      <div class="reason-card">
        <span class="reason-num">06</span>
        <div class="reason-icon"><FaBusinessTime /></div>
        <h4>Built for a Market Undergoing Structural Change</h4>
        <p>Businesses are increasingly evaluating how AI can improve productivity, reduce operating costs, and enable employees to focus on higher-value activities.

Nexora is being built around this structural transition.

Rather than attempting to predict which individual AI application will dominate, the company's strategy is to provide the infrastructure that allows businesses to continuously adopt and deploy new AI capabilities as the technology evolves.</p>
        {/* <div class="reason-metric">$12M GP</div>
        <div class="reason-metric-label">Management co-investment commitment</div>  */}
      </div>
    </div>
  </div>
</section>
    )
}

export default why;